import React, { useRef, useEffect, useState } from 'react'
import config from '../utils/config'
import Home from './home'
import Home2 from './homeStyle2'
import Home3 from './homeStyle3'
import Home4 from './homeStyle4'
import HomeStyle5 from "./homeStyle5";
const Index = () => {

    return (
        <>
            {
                config.template === 'style2' ? <Home2 /> : config.template === 'style3' ? <Home3 /> : config.template === 'style4' ? <Home4/> : config.template === 'style5'  ? <HomeStyle5 /> : <Home />
            }
        </>
    )
}

export default Index
